export enum ChannelCheckedType {
  CHANNELTYPE_DEFAULT = 0,
  CHANNELTYPE_NOTCHECKED = 1, // 未人工确认频道
  CHANNELTYPE_CHECKED = 2, // 已人工确认频道
}

export enum ChannelNovelSortType {
  CHANNELSORT_PUBLISH_TIME = 3,
  CHANNELSORT_UPDATE_TIME = 4,
  CHANNELSORT_HEAVY = 100,
}

export enum NovelSearchType {
  GETNOVELSEARCHTYPE_DEFAULT = 0,
  GETNOVELSEARCHTYPE_NOVEL_ID = 1,    // 小说id
  GETNOVELSEARCHTYPE_NOVEL_NAME = 2,  // 小说name
  GETNOVELSEARCHTYPE_NOVEL_TAG = 3,   // 小说标签
  GETNOVELSEARCHTYPE_USER_ID = 4,     // 作者id
  GETNOVELSEARCHTYPE_BOT_ID = 5,     // 角色id
}
